import React from 'react';
import { useTranslation } from 'react-i18next';
import { Gift, MapPin, Zap } from 'lucide-react';

const CARD_ICONS = [Gift, MapPin, Zap];
const CARD_KEYS = ['card1', 'card2', 'card3'];

const CARD_COLORS = [
  { bg: 'bg-secondary', border: 'border-primary/20', icon: 'text-primary', iconBg: 'bg-primary/10' },
  { bg: 'bg-white', border: 'border-slate-200', icon: 'text-primary', iconBg: 'bg-secondary' },
  { bg: 'bg-primary', border: 'border-primary', icon: 'text-primary-foreground', iconBg: 'bg-white/20' },
];

const EarlyAccessSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-secondary text-primary px-4 py-2 rounded-full text-sm font-medium mb-6">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
            Open Beta
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            {t('landing.realTestimonials.title')}
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            {t('landing.realTestimonials.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {CARD_KEYS.map((key, i) => {
            const Icon = CARD_ICONS[i];
            const color = CARD_COLORS[i];
            const isInverted = i === 2;
            return (
              <div
                key={key}
                className={`rounded-2xl p-8 border-2 ${color.bg} ${color.border} flex flex-col gap-5 hover:-translate-y-1 transition-transform duration-200`}
              >
                <div className={`w-14 h-14 ${color.iconBg} rounded-xl flex items-center justify-center`}>
                  <Icon className={`w-7 h-7 ${color.icon}`} />
                </div>
                <div>
                  <h3 className={`text-xl font-bold mb-3 ${isInverted ? 'text-white' : 'text-slate-900'}`}>
                    {t(`landing.realTestimonials.${key}.title`)}
                  </h3>
                  <p className={`leading-relaxed ${isInverted ? 'text-primary-foreground/80' : 'text-slate-600'}`}>
                    {t(`landing.realTestimonials.${key}.description`)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default EarlyAccessSection;
